import { search } from "../../assets/js/api.js";
import * as Helpers from "@/helpers/index.js"
import axios from 'axios';

export default {
  //namespaced: true,
  state: {
    fieldsAbsCampaign: [],
    fieldsRelCampaign: [],
    itemsCampaign: [],
    loadingCampaign: false,
    uniSizeCampaign: "",
    resultCountCampaign: "",
    panelDayCampaign: "",
    showToastErrorCampaign: false,
    cancelTokenSource: null,
  },
  getters: {
    fieldsAbsCampaign: state => state.fieldsAbsCampaign,
    fieldsRelCampaign: state => state.fieldsRelCampaign,
    itemsCampaign: state => state.itemsCampaign,
    loadingCampaign: state => state.loadingCampaign,
    uniSizeCampaign: state => state.uniSizeCampaign,
    resultCountCampaign: state => state.resultCountCampaign,
    panelDayCampaign: state => state.panelDayCampaign
  },
  mutations: {
    setFieldsAbsCampaign: (state, payload) => state.fieldsAbsCampaign = payload,
    setFieldsRelCampaign: (state, payload) => state.fieldsRelCampaign = payload,
    setItemsCampaign: (state, payload) => state.itemsCampaign = payload,
    setLoadingCampaign: (state, payload) => state.loadingCampaign = payload,
    setUniSizeCampaign: (state, payload) => state.uniSizeCampaign = payload,
    setResultCountCampaign: (state, payload) => state.resultCountCampaign = payload,
    setPanelDayCampaign: (state, payload) => state.panelDayCampaign = payload,
    setShowToastErrorCampaign: (state, payload) =>
      state.showToastErrorCampaign = payload,
    setCampaignState: (state, payload) => Object.assign(state, payload),
    setCancelTokenSource: (state, source) => state.cancelTokenSource = source,
  },
  actions: {
    resetReachCampaignState: context => {
      context.commit("setCampaignState", {
        fieldsAbsCampaign: [],
        fieldsRelCampaign: [],
        itemsCampaign: [],
        loadingCampaign: false,
        uniSizeCampaign: "",
        resultCountCampaign: "",
        panelDayCampaign: "",
        showToastErrorCampaign: false
      });
      if (context.state.cancelTokenSource) {
        context.state.cancelTokenSource.cancel('Resetting campaign state');
        context.commit('setCancelTokenSource', null);
      }
    },
    campaignSearchReach: context => {
      if (context.state.cancelTokenSource) {
        context.state.cancelTokenSource.cancel('New request initiated');
      }
      const cancelToken = axios.CancelToken.source();
      context.commit('setCancelTokenSource', cancelToken);

      context.commit("setItemsCampaign", []);
      context.commit("setFieldsAbsCampaign", []);
      context.commit("setFieldsRelCampaign", []);

      let campaignReachApiBody =
        context.getters["campaignReachApiBody/reachApiBody"];
      let storedMeasures = localStorage.getItem("campaignMeasures")
        ? JSON.parse(localStorage.getItem("campaignMeasures"))
        : [];
      campaignReachApiBody.measures = storedMeasures.filter(
        m => m.measure_type === 'reach_over_time' || m.measure_type === 'reach_over_time_percent',
      );
      if (campaignReachApiBody.measures == null || campaignReachApiBody.measures.length === 0) {
        return;
      }

      context.commit("setLoadingCampaign", true);

      search("QueryReachCampaignData", { payload: campaignReachApiBody }, cancelToken.token)
        .then(response => {
          if (response.statusCode) {
            context.commit("setShowToastErrorCampaign", true);
          }
          context.commit("setItemsCampaign", []);
          context.commit("setFieldsAbsCampaign", []);
          context.commit("setFieldsRelCampaign", []);
          if (response.data && response.info) {
            context.commit(
              "setUniSizeCampaign",
              Helpers.formatNumberWithThousandSeparator(response.info.total_universe_size)
            );
            context.commit(
              "setResultCountCampaign",
              Helpers.formatNumberWithThousandSeparator(response.info.total_row_count)
            );
            context.commit(
              "setPanelDayCampaign",
              response.info.panel_day.substring(0, 10)
            );

            response.data.forEach(element => {
              if (element.date_key != null) {
                element.date_key = element.date_key.substring(0, 10);
                element.date_key_rel = element.date_key.substring(0, 10);
              }
            });

            let firstField = { key: "date_key", label: "", thClass: "firstThRofClass" };
            let firstFieldRel = { key: "date_key_rel", label: "", thClass: "firstThRofClass" };
            let updatedFieldsAbs = [
              ...context.getters.fieldsAbsCampaign,
              firstField
            ];
            context.commit("setFieldsAbsCampaign", updatedFieldsAbs);
            let updatedFieldsRel = [
              ...context.getters.fieldsRelCampaign,
              firstFieldRel
            ];
            context.commit("setFieldsRelCampaign", updatedFieldsRel);
            let totalReach = { date_key: "Net Reach 1+ indv", date_key_rel: "Net Reach 1+ %" };
            let averageFreq = { date_key: "Avg Freq", date_key_rel: "Avg Freq" };
            let showTRP = context.rootState.config.runtime.ShowTRP;
            let trp = { date_key: "Sum TRP indv", date_key_rel: "Sum TRP %", isTRP: true, exportText: "Sum TRP" };
            let universeSize = { date_key: "Universe size indv", date_key_rel: "Universe size indv" };
            let emptyRow = { date_key: "" };
            let campaignSelectedReachObj = { ...context.getters["campaignReachForm/getSelectedReachObj"] };
            let selectedReachCriteriaText = campaignSelectedReachObj.options.filter(function (reachCriteria) {
              if (reachCriteria.value === this) return reachCriteria;
            }, campaignSelectedReachObj.selected)[0].selectedReachCriteriaText;
            for (let i = 0; i < response.summary.length; i++) {
              const measure = response.summary[i];
              const campaignReachMeasure = campaignReachApiBody.measures[i];
              const ageGroup = campaignReachMeasure.ageGroup;
              const reachAbsHeader = campaignReachMeasure.reachAbsHeader;
              const reachRelHeader = campaignReachMeasure.reachRelHeader;

              const labelAbs = `${reachAbsHeader} ${ageGroup}, ${selectedReachCriteriaText}`;
              const labelRel = `${reachRelHeader} ${ageGroup}, ${selectedReachCriteriaText}`;

              const fieldAbs = {
                key: measure.measure,
                label: labelAbs
              };
              const fieldRel = {
                key: measure.measure + "_rel",
                label: labelRel
              };
              context.commit("setFieldsAbsCampaign", [...context.getters.fieldsAbsCampaign, fieldAbs]);
              context.commit("setFieldsRelCampaign", [...context.getters.fieldsRelCampaign, fieldRel]);

              const totalReachValue = measure.total_reach === -1 ? "n/a" : Helpers.formatNumberWithThousandSeparator(Math.round(measure.total_reach));
              const averageFrequencyValue = measure.average_frequency === -1 ? "n/a" : measure.average_frequency.toString().replace('.', ',');
              const trpValue = measure.trp * measure.universe_size / 100;
              const universeSizeValue = measure.universe_size;

              const totalReachKey = measure.measure;
              const totalReachKeyRel = measure.measure + "_rel";

              const averageFreqKey = totalReachKey;
              const trpKey = totalReachKey;
              const universeSizeKey = totalReachKey;

              const totalReachObj = { [totalReachKey]: totalReachValue, [totalReachKeyRel]: response.data.slice(-1)[0].measuresRel[i] === -1 ? "n/a" : response.data.slice(-1)[0].measuresRel[i].toString().replace('.', ',') };
              const averageFreqObj = { [averageFreqKey]: averageFrequencyValue, [averageFreqKey + "_rel"]: averageFrequencyValue };
              const trpObj = { [trpKey]: Helpers.formatNumberWithThousandSeparator(Math.round(trpValue)), [trpKey + "_rel"]: measure.trp };
              const universeSizeObj = { [universeSizeKey]: Helpers.formatNumberWithThousandSeparator(universeSizeValue), [universeSizeKey + "_rel"]: Helpers.formatNumberWithThousandSeparator(universeSizeValue) };
              const emptyRowObj = { [totalReachKey]: "", [totalReachKeyRel]: "", [averageFreqKey]: "", [averageFreqKey + "_rel"]: "", [trpKey]: "", [trpKey + "_rel"]: "", [universeSizeKey]: "", [universeSizeKey + "_rel"]: "" };

              Object.assign(totalReach, totalReachObj);
              Object.assign(averageFreq, averageFreqObj);
              Object.assign(trp, trpObj);
              Object.assign(universeSize, universeSizeObj);
              Object.assign(emptyRow, emptyRowObj);
            }

            context.commit("setItemsCampaign", [
              ...context.getters.itemsCampaign,
              totalReach
            ]);
            context.commit("setItemsCampaign", [
              ...context.getters.itemsCampaign,
              averageFreq
            ]);
            if (showTRP) {
              context.commit("setItemsCampaign", [
                ...context.getters.itemsCampaign,
                trp
              ]);
            }
            context.commit("setItemsCampaign", [
              ...context.getters.itemsCampaign,
              universeSize
            ]);
            context.commit("setItemsCampaign", [
              ...context.getters.itemsCampaign,
              emptyRow
            ]);
            context.commit("setItemsCampaign", [
              ...context.getters.itemsCampaign,
              emptyRow
            ]);

            const fieldsAbs = [...context.getters.fieldsAbsCampaign];
            const fieldsRel = [...context.getters.fieldsRelCampaign];
            for (let i = 0; i < response.data.length; i++) {
              for (let j = 0; j < fieldsAbs.length; j++) {
                if (fieldsAbs[j].key !== "date_key") {
                  if (!response.data[i][fieldsAbs[j].key]) {
                    response.data[i][fieldsAbs[j].key] =
                      response.data[i].measures[j - 1] == -1
                        ? "n/a"
                        : Helpers.formatNumberWithThousandSeparator(response.data[i].measures[j - 1]);
                  }
                }
              }
              for (let j = 0; j < fieldsRel.length; j++) {
                if (fieldsRel[j].key !== "date_key") {
                  if (!response.data[i][fieldsRel[j].key]) {
                    let measureRelValue = response.data[i].measuresRel[j - 1];
                    if (measureRelValue % 1 == 0)
                      measureRelValue = measureRelValue.toFixed(1);
                    response.data[i][fieldsRel[j].key] =
                      measureRelValue == -1 ? "n/a" : measureRelValue.toString().replace('.', ',');
                  }
                }
              }
            }
            context.commit("setFieldsAbsCampaign", fieldsAbs);
            context.commit("setItemsCampaign", [
              ...context.getters.itemsCampaign,
              ...response.data
            ]);
          }
          context.commit("setLoadingCampaign", false);
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.warn('Request canceled:', error.message); // Log cancellation
          } else {
            context.commit("setShowToastErrorCampaign", true);
            context.commit("setLoadingCampaign", false);
          }
        });
    }
  }
};
